export const bancoValorColors = {
  primaryBackground: '#f2f0ec',
  onImageBackground: '#fff8ea',
  onIconsAndTextButtons: '#ffffff',
  onIconsAndTextButtonsVariant: '#ffffff',
  secondaryBackground: '#fbfaf6',
  selectedAndDetailBackground: '#e0dbd3',
  borderLine: '#d4c192',
  placeholderText: '#c8b076',
  menuBackground: '#070603',
  currentStep: '#c59913',
  onSecondaryAndDetailBackground: '#070603',
  hoverMenuBackground: '#4d4d4d',
  mainFocused: '#4e3806',
  highlight: '#c59913',
  tradingDown: '#c59913',
  tradingUp: '#c59913',
  off: '#e3dbcf',
  lower: '#747066',
  footerBackground: '#070603',
  onFooterBackground: '#fff8ea',
  popupWindow: '#fff8ea',
  popupWindowTitle: '#000000',
  iconsOnFooterBackground: '#c59913',
  primaryDisabledBackground: '#dfdcd1',
  secondaryDisabledBackground: '#eceae7',
  primaryDisabledText: '#c1b59c',
  secondaryDisabledText: '#d4c192',
  scrollOnDetailBackground: '#cac2b6',
  scrollOnPrimaryBackground: '#e0dbd3',
  infoBackground: '#ECE9E0',
  nextStep: '#cbc1b1',
  previousStep: '#b7a372',
  iconsOnMenuBackground: '#7c6c17',
  mainFocusedSoothing: '#d9c4a6',
  highlightSoothing: '#fae8b2',
  pillBorder: '#b78f31',
  pillBackgroundGloomy: '#dacea8',
  pillBackgroundLight: '#f3f0e1',
  dividerOnPrimaryBackground: '#e8ddcc',
  label: '#a18d6c',
  homePageBackground: '#f2f0ec',
  onHomePageBackground: '#070603',
  refreshButton: '#070603',
  dashboardDivider: '#ddd2c1',
  star: '#ffb006',
  up: '#8fbc0e',
  down: '#ff3838',
  inert: '#a18d6c',
  scrollOnInfoBackground: '#d7d0c0',
  actionBar: '#E5E1D7',
  onInfoBackground: '#070603',
  onPrimaryBackground: '#070603',
  lockedBackground: 'rgba(47, 42, 28, 0.65)',
  hoverHighlight: '#f0c43e',
  variantOnInfoBackground: '#4e3806',
  variantOnPrimaryBackground: '#070603',
  graphBackground: '#ede8e1',
  disabledAndHoverOnInfoBackground: '#c2b493',
  disabledOnPrimaryBackground: '#c2b493',
  iconsSelectedOnMenu: '#ffffff',
  selectedBarOnMenu: '#c59913',
  selectedTextButtonMenu: '#c59913',
  newsBackground: '#e2ded6',
};
